import React, { useState, useEffect } from 'react'
import { Chart } from '@scuf/charts'
import baseServices from '../../../services/base.services'

const ArsenitoDespacho = ({ body, height, name }) => {

    const [state, setState] = useState(null)

    // Arsenito
    useEffect(() => {
        const getTTeg = async () => {
            try {
                var response = await baseServices.getDataTostacionDMH2(body)
                if (response.data && response.data.length > 0) {
                    let arrayValor1 = [], arrayValor2 = []

                    response.data.forEach((x, i) => {
                        arrayValor1.push(x.Fecha)
                        arrayValor2.push(x.Valor)
                    })

                    setState({
                        valor1: arrayValor1,
                        valor2: arrayValor2
                    })
                    setTimeout(() => { getTTeg() }, 60000)
                }
            }
            catch (e) {
                console.log(e)
                getTTeg()
            }         
        }
        getTTeg()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {
                state ?
                    <Chart
                        animation={true}
                        height={height}
                    >
                        <Chart.Area
                            name={name}
                            data={state.valor2}
                            showInLegend={false}
                        />

                        <Chart.XAxis
                            categories={state.valor1}
                        ></Chart.XAxis>

                        <Chart.YAxis
                            gridLineWidth='0'
                        ></Chart.YAxis>
                    </Chart>
                    :
                    <div className='letter-origin'>...No hay datos</div>
            }

        </>
    )
}

export default ArsenitoDespacho